import { render, staticRenderFns } from "./HorseSearchDuplicate.vue?vue&type=template&id=2768dba6&"
import script from "./HorseSearchDuplicate.vue?vue&type=script&lang=js&"
export * from "./HorseSearchDuplicate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports